import React from 'react';
import { Typography, List } from 'antd';
import './index.less';
import { RightOutlined } from '@ant-design/icons';
class itemList extends React.PureComponent {
  render() {
    const { Title } = Typography;
    const { header, data } = this.props;

    return (
      <div className="item-content-div">
        <List
          className="item-list"
          header={
            <Typography>
              <Title level={3}>{header}</Title>
            </Typography>
          }
          dataSource={data}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                avatar={<RightOutlined/>}
                description={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.desc,
                    }}
                  />
                }
              />
            </List.Item>
          )}
        />
      </div>
    );
  }
}
export default itemList;
